export default class WIContractOwnership {
    id: number;
    projectId: number;
    ownerLookUpId: number;
    parentOwnershipId: number;
    decimalInterest: number;
    ownershipId: number;
    contractLookupId: number;
    note: string;
    orriOwnerships: Array<WIContractOwnership>;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/WIContractOwnership.ts